/*
 * AI API — dispatches to the localStorage mock or the real HTTP backend based
 * on USE_MOCK_API. Signatures are identical across both.
 */
import { USE_MOCK_API } from './httpClient'
import * as mock from './ai.mock'
import * as http from './ai.http'

const impl = USE_MOCK_API ? mock : http

export const planTrip = impl.planTrip
export const applyPlan = impl.applyPlan
export const listRecommendations = impl.listRecommendations
